module.exports = __webpack_public_path__ + "00daf523a2014fbcbc71c6a5d93e52c6.png";